import { Global, Collection } from '@sourceflow-uk/sourceflow-sdk';
import SeoHead from '../../../../components/SeoHead';
import MainBanner from '../../../../components/MainBanner';
import ImageWithTextWithCardPadding from '../../../../components/ImageWithTextWithCardPadding';

export default function FeaturedEmployersPage({
    global,
    all_featured_employers
}) {

    return (
        <>
            <SeoHead
                page_name={`Featured Employers| The global house of tech and transformation recruitment | Lorien | United States`}
                canonical_link={`job-seekers/featured-employers`}
                en_gb={false}
                en_us={true}
            />
            <MainBanner
                global={global}
                pathPrefix={`us.job_seekers.featured_employers_page.main_banner`}
                customClass={``}
                content={
                    <>
                        <h1>Featured Employers</h1>
                    </>
                }
                imageURL1={`/site-assets/images/main-banner.jpg`}
                imageALT1={`Main Banner`}
                imageURL2={`/site-assets/images/sub-banner-job-seekers.png`}
                imageALT2={`Overlay Main Banner`}
                displayImage1={false}
            />
            <ImageWithTextWithCardPadding
                global={global}
                pathPrefix={`us.job_seekers.featured_employers_page.image_with_text_with_card_padding`}
                customClass={`py-5 grayGradientBg`}
                content={
                    <>
                        <h2>Want to be featured as an Employer?</h2>
                        <p>At Lorien, we support world-leading organisations in taking their technology above and beyond their competitors. Likewise, we encourage talented candidates to take the next step in their career with our bespoke service that offers candidates unique roles with high-profile employers that are exclusively partnered with Lorien. Candidates can browse through the roles to see what best aligns with their desired career path and ambitions on each business page.</p>
                    </>
                }
                buttonLink={`/us/contact-us/`}
                buttonTitle={`Get in Touch`}
                post_button_url_slug={true}
                post={all_featured_employers}
                previewImage={true}
            />
        </>
    )
}

export async function getStaticProps({ params }) {
    const global = (await Global()).toJson();
    const featured_employers = await Collection('featured_employers');

    const all_featured_employers = featured_employers
        .orderBy('_order')
        .getItems()
        .filter(post => post?.country?.includes("United States"));
    return {

        props: {
            global,
            all_featured_employers
        }

    }
}
